<div class="TransferConfirmation-warning empty-warning-message">
  <div class="TransferConfirmation-warning-icon">
    <ion-icon name="warning"></ion-icon>
  </div>

  <p class="TransferConfirmation-warning-info">
    {{ 'transfer_empty.text' | translate }}.
  </p>
</div>
